import React, { PureComponent } from 'react';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'reactstrap';

class DropDoc extends PureComponent {
  static propTypes = {
    // name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func,
    text: PropTypes.string,
    smaller: PropTypes.bool,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
      })),
    ]),
  };

  static defaultProps = {
    onRemove: () => {},
    smaller: false,
    text: 'Déposez ici vos documents',
    value: [],
  }

  constructor() {
    super();
    this.state = {};
    this.onDrop = this.onDrop.bind(this);
  }

  onDrop(file) {
    const { onChange } = this.props;
    onChange(file);
    // onChange(file.map(fl => Object.assign(fl, {
    //   preview: URL.createObjectURL(fl),
    // })));
  }

  removeFile(url, e) {
    const { onRemove, value } = this.props;
    e.preventDefault();
    // console.log(value);
    // const end = value.filter(val => val.url !== url);
    // console.log(end);
    // onChange(end);
    onRemove(value.filter(val => val.url !== url));
  }

  render() {
    const {
      value,
      text,
      smaller,
    } = this.props;

    const files = value;

    return (
      <Row className="fullWidth ml-0">
        <Col className="pl-0 pr-0" sm={12} md={(files && Array.isArray(files) && files.length) > 0 || smaller ? 6 : 12}>
          <div className="dropzone dropzone--multiple">
            <Dropzone
              accept="image/*, application/pdf, application/msword, .doc, .docx, .txt, .xlsx, .csv"
              name="doc"
              multiple
              maxSize={10000000}
              onDropRejected={() => alert('Taille maximum du fichier : 10Mb')} // eslint-disable-line no-alert
              onDrop={(fileToUpload) => {
                this.onDrop(fileToUpload);
              }}
            >
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()} className="dropzone__input">
                  <div className="dropzone__drop-here">
                    <span className="lnr lnr-upload" /> {text}
                  </div>
                  <input {...getInputProps()} />
                </div>
              )}
            </Dropzone>
          </div>
        </Col>
        <Col className="pr-0" sm={12} md={files && Array.isArray(files) && files.length > 0 ? 6 : 0}>
          {files && Array.isArray(files) && files.length > 0
          && (
            files.map(doc => (
              <div className="docItem" key={doc.name}>
                <div style={{ display: 'inline' }}>
                  {doc.name}
                </div>
                <Button close onClick={e => this.removeFile(doc.url, e)} />
              </div>
            ))
          )}
        </Col>
      </Row>
    );
  }
}

export default DropDoc;
